import { c as _c } from "react/compiler-runtime";
import type { ReactNode } from 'react';
const DESKTOP_MAX_PER_ROW = 10;
interface CategoryGroupRowsProps {
  items: ReactNode[];
  className?: string;
  rowClassName?: string;
}
export const CategoryGroupRows = t0 => {
  const $ = _c(11);
  const {
    items,
    className,
    rowClassName
  } = t0;
  const rowCount = Math.max(1, Math.ceil(items.length / DESKTOP_MAX_PER_ROW));
  const basePerRow = Math.floor(items.length / rowCount);
  const longRowCount = items.length % rowCount;
  let t1;
  if ($[0] !== basePerRow || $[1] !== items || $[2] !== longRowCount || $[3] !== rowCount) {
    t1 = Array.from({
      length: rowCount
    }, (_, rowIndex) => {
      const shortRowCount = rowCount - longRowCount;
      const start = rowIndex * basePerRow + Math.max(0, rowIndex - shortRowCount);
      return items.slice(start, start + basePerRow + (rowIndex >= shortRowCount ? 1 : 0));
    });
    $[0] = basePerRow;
    $[1] = items;
    $[2] = longRowCount;
    $[3] = rowCount;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  const rows = t1;
  let t2;
  if ($[5] !== rowClassName || $[6] !== rows) {
    t2 = rows.map((rowItems, rowIndex_0) => <div key={rowIndex_0} className={rowClassName}>{rowItems}</div>);
    $[5] = rowClassName;
    $[6] = rows;
    $[7] = t2;
  } else {
    t2 = $[7];
  }
  let t3;
  if ($[8] !== className || $[9] !== t2) {
    t3 = <div className={className}>{t2}</div>;
    $[8] = className;
    $[9] = t2;
    $[10] = t3;
  } else {
    t3 = $[10];
  }
  return t3;
};